import styled from 'styled-components';

export const Wrapper = styled.div`
  min-height: 100vh;
  background:
    radial-gradient(circle at top left, rgba(191, 167, 214, 0.35), transparent 28%),
    radial-gradient(circle at bottom right, rgba(168, 196, 178, 0.32), transparent 32%),
    linear-gradient(180deg, #f3ede6 0%, #ede4da 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1rem 3rem 1rem;
  font-family: 'Inter', sans-serif;
`;

export const Title = styled.h1`
  font-size: clamp(2.4rem, 5vw, 4rem);
  font-weight: 700;
  line-height: 1.02;
  color: #3d3146;
  margin-bottom: 1rem;
  text-align: left;
`;

export const Description = styled.p`
  color: #675d69;
  font-size: 1.05rem;
  max-width: 580px;
  line-height: 1.7;
  text-align: left;
  margin-bottom: 1.5rem;
`;

export const Card = styled.div`
  background: rgba(255, 248, 242, 0.72);
  border-radius: 28px;
  box-shadow: 0 20px 48px rgba(90, 74, 94, 0.12);
  border: 1px solid rgba(118, 101, 123, 0.12);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-width: 0;
  width: 100%;
  backdrop-filter: blur(12px);
`;

export const DownloadButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`;

export const DownloadButton = styled.button`
  background: none;
  border: 1px solid rgba(118, 101, 123, 0.12);
  border-radius: 18px;
  padding: 0.35rem 0.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 14px 26px rgba(90, 74, 94, 0.12);
    border-color: rgba(113, 144, 122, 0.28);
  }
`;

export const QRLink = styled.a`
  color: #5f7565;
  font-size: 0.95rem;
  text-decoration: none;
  margin-top: 0.5rem;
  cursor: pointer;
  background: none;
  border: none;
  font-weight: 600;
  &:hover {
    color: #485b4d;
  }
`;

export const RegisterButton = styled.button`
  background: linear-gradient(135deg, #8d6f92 0%, #73907a 100%);
  color: #fffaf4;
  font-size: 1.05rem;
  font-weight: 700;
  border: none;
  border-radius: 16px;
  padding: 0.95rem 1.5rem;
  margin-top: 0.75rem;
  box-shadow: 0 16px 34px rgba(111, 86, 116, 0.18);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 18px 36px rgba(111, 86, 116, 0.22);
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

export const CardIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  color: #4f6154;
  font-size: 28px;
  margin-right: 12px;
  box-sizing: border-box;
  border-radius: 14px;
  background: rgba(143, 165, 149, 0.18);
`;

export const CardTitle = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 1.15rem;
  color: #3d3146;
  letter-spacing: 0;
  margin-right: 0;
`;

export const CardDescription = styled.div`
  color: #675d69;
  font-size: 0.98rem;
  text-align: left;
  line-height: 1.7;
  margin-bottom: 1.5rem;
  margin-top: 0;
  max-width: 460px;
`;

export const LoginSectionStyled = styled.div`
  width: 100%;
  margin-top: 1.75rem;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(118, 101, 123, 0.12);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const LoginTitleStyled = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 1.05rem;
  color: #3d3146;
  text-align: left;
`;

export const LoginButtonStyled = styled.button`
  background: rgba(255, 248, 242, 0.8);
  color: #5d5561;
  font-size: 0.98rem;
  font-weight: 600;
  border: 1px solid rgba(118, 101, 123, 0.16);
  border-radius: 14px;
  padding: 0.85rem 1.35rem;
  cursor: pointer;
  transition: transform 0.2s ease, border-color 0.2s ease;
  box-shadow: none;
  &:hover {
    transform: translateY(-1px);
    border-color: rgba(113, 144, 122, 0.32);
  }
`;

export const HeroShell = styled.div`
  width: 100%;
  max-width: 1080px;
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(320px, 0.95fr);
  gap: 1.5rem;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 1rem;
`;

export const Eyebrow = styled.span`
  display: inline-flex;
  align-self: flex-start;
  padding: 0.45rem 0.85rem;
  border-radius: 999px;
  background: rgba(143, 165, 149, 0.2);
  color: #4f6154;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

export const Accent = styled.span`
  color: #7b617f;
`;

export const SimpleList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

export const SimplePill = styled.div`
  padding: 0.8rem 1rem;
  border-radius: 16px;
  background: rgba(255, 248, 242, 0.7);
  border: 1px solid rgba(118, 101, 123, 0.12);
  color: #5d5561;
  font-size: 0.92rem;
  font-weight: 600;
  box-shadow: 0 10px 26px rgba(90, 74, 94, 0.08);
`;
